module.exports = __webpack_public_path__ + "static/img/introduction.a06dfd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/introduction.jpg
// module id = 5hvv
// module chunks = 0